import { css } from 'styled-components';

import { breakpoints, colors, fontWeights, transition } from 'theme';
import { getStaticImageSrc } from 'utils/getImageSrc';

const blueLoopIcon = () => getStaticImageSrc('blue-loops.svg');
const emailSignUpIcon = () => getStaticImageSrc('email-signup.svg');

// eslint-disable-next-line import/no-default-export
export default css`
  .idealist-email-signup-block {
    padding: 80px 20px;
    margin: 0 -24px;
    background-image: url(${blueLoopIcon});
    background-size: cover;
    background-position: center;
    color: white;
    text-align: center;

    @media (min-width: ${breakpoints[2]}) {
      margin: 0 -48px;
      border-radius: 24px;
    }

    &.bg-subscribe {
      background-image: url(${emailSignUpIcon});
    }

    input:not([type='submit']) {
      width: 100%;
      height: 60px;
      margin: 0;
      border: 0;
      padding: 11px 12px;
      font: inherit;
      font-size: 18px;
      color: #484848;
      background-color: #ffffff;
      &:first-child {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }
      &:last-child {
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      &:not(:first-child) {
        border-top: 1px solid ${colors.elementGrey};
      }
    }

    button,
    input[type='submit'] {
      display: inline-block;
      box-sizing: content-box;
      vertical-align: middle;
      padding: 8px 40px;
      max-width: 440px;
      box-shadow: 0 0 0 1px white inset;
      background: none;
      color: white;
      appearance: none;
      border: none;
      border-radius: 9999px;
      cursor: pointer;
      -webkit-font-smoothing: antialiased;
      text-align: center;
      text-decoration: none;
      font-family: inherit;
      font-size: 16px;
      font-weight: ${fontWeights.semiBold};
      letter-spacing: 0.5px;
      transition: all ${transition};
      &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
      }
      &:hover,
      &:focus {
        background-color: ${colors.brandGreen};
        box-shadow: 0 0 0 1px ${colors.brandGreen} inset;
        color: ${colors.white};
      }
    }

    h2 {
      &::before {
        content: none;
      }
    }
  }
`;
